export default __webpack_public_path__ + "static/media/btn-zeroback-stop-nl_dt@3x.bd10168d.png";